import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';

import { HotCompressInstructions } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';

@Component({
    selector: 'app-hot-compress-item',
    templateUrl: './hot-compress-item.component.html',
    styleUrl: './hot-compress-item.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent,],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotCompressItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: HotCompressInstructions;
	@Input() startLabel!: string;
    @Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as HotCompressInstructions;
	}

	constructor() {
	}
}
